import React from 'react';
import PropTypes from 'prop-types';
import {
  FluentErrorView,
  BrowserDeprecationView,
} from '@bingads-webui-campaign-react/fluent-error-view';
import type { BrowserDeprecationViewI18n } from '@bingads-webui-campaign-react/fluent-error-view';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';

const isIE11 = () => (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1);

interface DefaultGlobalErrorViewProps {
  i18n: BrowserDeprecationViewI18n;
  shouldShowRefreshLink?: boolean;
}

function DefaultGlobalErrorView({
  i18n,
  shouldShowRefreshLink,
}: DefaultGlobalErrorViewProps) {
  return isIE11() ?
    (<BrowserDeprecationView className="campaign-ui-error-page" i18n={i18n} />) :
    <FluentErrorView className="campaign-ui-error-page" i18n={i18n} showRefresh={shouldShowRefreshLink} />;
}

(DefaultGlobalErrorView as React.FC<DefaultGlobalErrorViewProps>).propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    getLocale: PropTypes.func.isRequired,
  }).isRequired,
  shouldShowRefreshLink: PropTypes.bool,
} as React.WeakValidationMap<DefaultGlobalErrorViewProps>;

(DefaultGlobalErrorView as React.FC<DefaultGlobalErrorViewProps>).defaultProps = {
  shouldShowRefreshLink: true,
};

const Wrapped
  = withI18nConsumer(DefaultGlobalErrorView);
export { Wrapped as DefaultGlobalErrorView };
